import React, { FC, useState } from 'react';
import { Trans } from 'react-i18next';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';

const LinkErrorDialog: FC = () => {
  const [open, setOpen] = useState(true);

  function handleClose() {
    setOpen(false);
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Trans i18nKey="auth:linkErrorTitle" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Trans i18nKey="auth:linkErrorDescription" />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" variant="contained" autoFocus>
          <Trans i18nKey="walkthrough:ok_got_it" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LinkErrorDialog;
